import React from "react";
import appstore from "../../assets/images/appstore.svg";
import logo from "../../assets/logos/everlywell-logo.svg";
import Accordion from "../Accordion";
import { Row, Col } from "../Grid";
import * as Icons from "../Icons";
import FooterAccordionItem from "./FooterAccordionItem";
import { shopCategories, aboutCategories, moreCategories, legalLinks, socialLinks } from "./links";
import * as S from "./styles";
import SubscribeInput from "./SubscribeInput";

var content = {
  Shop: shopCategories,
  About: aboutCategories,
  More: moreCategories
},
    defaultDisclaimer = function defaultDisclaimer() {
  return React.createElement(React.Fragment, null, "Everlywell offers health and wellness solutions including laboratory testing for wellness monitoring, informational and educational use. With the exception of certain diagnostic test panels, list available", " ", React.createElement("a", {
    href: "https://support.everlywell.com/article/365-what-diagnostic-tests-does-everlywell-offer?_ga=2.16404342.156311377.1610383825-325840488.1607986328"
  }, "here"), ", the tests we offer access to are not intended to diagnose or treat disease. None of our tests are intended to be a substitute for seeking professional medical advice, help, diagnosis, or treatment. For regulatory reasons, our tests are not available in NY with the exception of COVID-19.");
},
    IsFDADisclaimerText = function IsFDADisclaimerText(_ref) {
  var e = _ref.showFDADisclaimer;
  return e ? React.createElement(S.FDADisclaimerText, null, "*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.") : null;
},
    IsMedicareText = function IsMedicareText(_ref2) {
  var e = _ref2.showMedicareDisclaimer;
  return e ? React.createElement(S.DisclaimerText, null, "*We do not accept Medicare Part B or Medicaid fee-for-service coverage. However, we do accept Medicare Advantage and Medicaid managed care plans.") : null;
},
    IsAvailableForSelectConditions = function IsAvailableForSelectConditions(_ref3) {
  var e = _ref3.showAvailableForSelectConditionsDisclaimer;
  return e ? React.createElement(S.DisclaimerText, null, "**Available for select conditions. Everlywell does not provide professional medical advice. Rather, the Everlywell platform can be used to connect with an independent healthcare provider who can assess your condition. All prescription medications require a consultation with an independent healthcare provider. Prescriptions can be filled by a pharmacy of your choice. Additional terms and conditions apply.") : null;
},
    LegitScriptCertificate = function LegitScriptCertificate() {
  return React.createElement("a", {
    href: "https://legitscript.com",
    target: "_blank",
    rel: "noreferrer",
    title: "Verify LegitScript Approval"
  }, React.createElement("img", {
    src: "https://static.legitscript.com/seals/4099199.png",
    alt: "LegitScript approved",
    width: "140",
    height: "100"
  }));
};

export var Footer = function Footer(_ref4) {
  var _ref4$disclaimer = _ref4.disclaimer,
      e = _ref4$disclaimer === void 0 ? defaultDisclaimer : _ref4$disclaimer,
      t = _ref4.logoAlt,
      a = _ref4.logoHeight,
      r = _ref4.logoSrc,
      l = _ref4.logoWidth,
      c = _ref4.onSubscribeSubmit,
      _ref4$showFDADisclaim = _ref4.showFDADisclaimer,
      o = _ref4$showFDADisclaim === void 0 ? !0 : _ref4$showFDADisclaim,
      _ref4$showMedicareDis = _ref4.showMedicareDisclaimer,
      n = _ref4$showMedicareDis === void 0 ? !1 : _ref4$showMedicareDis,
      _ref4$showAvailableFo = _ref4.showAvailableForSelectConditionsDisclaimer,
      i = _ref4$showAvailableFo === void 0 ? !1 : _ref4$showAvailableFo,
      s = _ref4.onClickLink;
  return React.createElement(S.Footer, {
    "data-testid": "footer"
  }, React.createElement(S.Container, null, React.createElement(Row, {
    center: "xs",
    start: "md"
  }, React.createElement(S.MobileLogoWrapper, {
    xs: 12
  }, React.createElement(S.Logo, {
    alt: t || "Everlywell",
    src: r || logo,
    width: l || "107",
    height: a || "24"
  }))), React.createElement(Row, null, React.createElement(S.MobileAccordionCol, {
    xs: 12
  }, React.createElement(Accordion.Wrapper, null, Object.entries(content).map(function (e, t) {
    return React.createElement(FooterAccordionItem, {
      key: "link-section-".concat(t),
      heading: e[0],
      listOfLinkObjects: e[1],
      showBorderBottom: !0,
      onClickLink: s
    });
  }))), React.createElement(S.FlexCol, {
    xs: 12
  }, React.createElement(S.DesktopLogoWrapper, null, React.createElement(S.Logo, {
    alt: "Everlywell",
    src: logo,
    width: "107",
    height: "24"
  })), React.createElement(S.DesktopLinksWrapper, null, Object.entries(content).map(function (e, t) {
    return React.createElement(S.LinkSection, {
      key: "dt-link-section-".concat(t)
    }, React.createElement(S.CategoryTitle, null, e[0]), React.createElement("ul", null, Object.entries(e[1]).map(function (e, t) {
      return React.createElement(S.CategoryListItem, {
        key: "footer-link-".concat(t)
      }, React.createElement(S.FooterLink, {
        href: e[1],
        onClick: function onClick() {
          return t = e[0], void (s && s(t));
          var t;
        }
      }, e[0]));
    })));
  })), React.createElement(S.SubscribeAndSocialSection, null, React.createElement(S.SubscribeHeading, null, "Subscribe to our newsletter"), React.createElement(S.SubscribeDescription, null, "Get the latest updates of products and company updates"), React.createElement(S.SubscribeInputWrapper, null, React.createElement(SubscribeInput, {
    onSubscribeSubmit: c
  })), React.createElement(S.SocialIconsWrapper, null, React.createElement(S.IconWrapper, {
    "aria-label": "Facebook",
    href: socialLinks.Facebook,
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Icons.Facebook, null)), React.createElement(S.IconWrapper, {
    "aria-label": "Instagram",
    href: socialLinks.Instagram,
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Icons.Instagram, null)), React.createElement(S.IconWrapper, {
    "aria-label": "Twitter",
    href: socialLinks.Twitter,
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Icons.Twitter, null)), React.createElement(S.IconWrapper, {
    "aria-label": "LinkedIn",
    href: socialLinks.LinkedIn,
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Icons.LinkedIn, null))), React.createElement(S.SocialIconsWrapper, null, React.createElement("a", {
    href: "https://apps.apple.com/app/apple-store/id1614888856?pt=124169076&ct=footer&mt=8",
    onClick: function onClick() {
      return s && s("Download App");
    }
  }, React.createElement("img", {
    src: appstore,
    alt: "Download on the App Store",
    width: l || "119",
    height: a || "40"
  })))))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(IsFDADisclaimerText, {
    showFDADisclaimer: o
  }))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(S.DisclaimerText, null, e()))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(IsMedicareText, {
    showMedicareDisclaimer: n
  }))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(IsAvailableForSelectConditions, {
    showAvailableForSelectConditionsDisclaimer: i
  }))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(S.LegalSectionWrapper, null, React.createElement(S.LegalText, null, "© ", new Date().getFullYear(), " Everlywell, Inc. All rights reserved."), React.createElement(S.LegalLinkList, null, Object.entries(legalLinks).map(function (e, t) {
    return React.createElement(S.ListItem, {
      key: "dt-legal-li-".concat(t)
    }, e[1].includes("accessibility") ? React.createElement(S.LegalLink, {
      "aria-label": "Click to view our Accessibility Statement or contact us with accessibility-related questions",
      href: e[1]
    }, e[0]) : React.createElement(S.LegalLink, {
      href: e[1]
    }, e[0]));
  }))))), React.createElement(S.AddressSectionWrapper, null, React.createElement(S.AddressContainer, {
    xs: 12,
    md: 6
  }, React.createElement(S.Address, null, React.createElement("p", null, "823 Congress Ave Ste 1200, Austin, Texas, 78701"), React.createElement(S.FooterLink, {
    href: "mailto:contactus@everlywell.com"
  }, "contactus@everlywell.com"))), React.createElement(S.LegitScriptsContainer, {
    xs: 12,
    md: 6
  }, React.createElement(LegitScriptCertificate, null)))));
};
export default Footer;